// Angular + external
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FlexLayoutModule } from "@angular/flex-layout";
/**********************************************************/
// BFX

import { BfxFooterBarHandlerService } from "./services/bfx-footer-bar-handler.service";
import { BfxFooterBarComponent } from "./bfx-footer-bar.component";

@NgModule({
  declarations: [BfxFooterBarComponent],
  exports: [BfxFooterBarComponent],
  imports: [CommonModule, FormsModule, FlexLayoutModule],
  providers: [BfxFooterBarHandlerService, provideHttpClient(withInterceptorsFromDi())],
})
export class BfxFooterBarModule {}
